/** Parse and shorten quickbar.placeholder without clipping mid-token. */

export const QUICKBAR_PLACEHOLDER_MARKERS = ['#', '@', '~', '+', '>'];

/**
 * @param {string} full
 * @returns {{ base: string, tokens: string[] }}
 */
export function parseQuickbarPlaceholder(full) {
  const ellipsisIndex = full.indexOf('...');
  if (ellipsisIndex === -1) {
    return { base: full.trim(), tokens: [] };
  }
  const baseEnd = ellipsisIndex + 3;
  const base = full.slice(0, baseEnd).trimEnd();
  const rest = full.slice(baseEnd).trim();
  const tokens = rest ? rest.split(/\s+/) : [];
  return { base, tokens };
}

/**
 * @param {string} base
 * @param {string[]} tokens
 */
export function formatQuickbarPlaceholder(base, tokens) {
  return tokens.length ? `${base} ${tokens.join(' ')}` : base;
}

/**
 * Drops `dropCount` tokens (longest first) from a quickbar placeholder string.
 * @param {string} full
 * @param {number} dropCount
 */
export function dropQuickbarPlaceholderTokens(full, dropCount) {
  if (dropCount <= 0) return full;
  const { base, tokens } = parseQuickbarPlaceholder(full);
  if (tokens.length === 0) return base;
  const removeCount = Math.min(dropCount, tokens.length);
  const ranked = tokens
    .map((token, index) => ({ token, index, len: token.length }))
    .sort((a, b) => b.len - a.len || b.index - a.index);
  const remove = new Set(
    ranked.slice(0, removeCount).map((entry) => entry.index),
  );
  const kept = tokens.filter((_, index) => !remove.has(index));
  return formatQuickbarPlaceholder(base, kept);
}

/**
 * @param {string} text
 */
export function quickbarPlaceholderHasAllMarkers(text) {
  return QUICKBAR_PLACEHOLDER_MARKERS.every((marker) => text.includes(marker));
}

/**
 * @param {string} breakpoint
 * @param {{ narrowField?: boolean }} [options]
 */
export function quickbarPlaceholderDropCount(breakpoint, options = {}) {
  const { narrowField = false } = options;
  let dropCount = 0;
  if (breakpoint === 'l' || breakpoint === 'm') {
    dropCount = 1;
  } else if (breakpoint === 'xs' || breakpoint === 's') {
    dropCount = 2;
  }
  if (narrowField) {
    dropCount += 1;
  }
  return dropCount;
}
